import './page-loading.scss'

const PageLoading = () => {
    return (
        <div className="page-loading-page-div">
            <div className="border">
                <div className="svg-icon">
                    <svg version="1.0" width="100px" height="100px" viewBox="0 0 262.000000 262.000000"
                        preserveAspectRatio="xMidYMid meet">

                        <g transform="translate(0.000000,262.000000) scale(0.100000,-0.100000)"
                            fill="var(--background-c3)" stroke="none">
                            <path d="M1331 2252 c-46 -44 -123 -88 -191 -109 -53 -16 -54 -16 -26 -24 39
-11 86 -57 86 -86 0 -12 -27 -93 -59 -180 -61 -160 -191 -497 -194 -500 -1 0
-42 8 -92 19 -114 26 -341 30 -465 8 l-85 -15 125 -7 c148 -8 250 -33 373 -91
89 -43 100 -56 73 -92 -13 -18 -16 -18 -94 18 -45 20 -89 38 -99 40 -10 2 -49
13 -87 25 -78 25 -254 43 -347 36 -57 -4 -199 -39 -199 -48 0 -2 30 -2 68 0
84 4 240 -18 324 -47 65 -22 133 -57 276 -142 78 -46 115 -56 81 -21 -29 28
-332 184 -361 184 -26 1 -152 48 -133 51 137 15 270 -14 459 -101 79 -36 106
-43 106 -29 0 6 5 7 10 4 6 -4 8 -10 5 -15 -14 -23 184 -131 370 -201 l100
-38 -70 0 c-95 -1 -253 38 -360 89 -45 21 -75 29 -75 20 0 -5 -9 -9 -20 -7
-17 2 -27 -14 -59 -88 -62 -147 -90 -195 -145 -250 -47 -47 -103 -75 -150 -75
-9 0 -16 -6 -16 -12 0 -10 66 -13 295 -13 214 0 295 3 295 11 0 7 -21 15 -47
19 -122 18 -203 107 -203 222 0 55 28 163 45 169 6 3 46 -12 89 -32 128 -59
247 -84 395 -84 111 0 285 20 299 35 3 3 -22 5 -55 5 -145 0 -352 61 -513 150
-58 32 -117 64 -133 71 -21 10 -26 17 -21 33 4 12 7 27 7 34 0 19 14 15 85
-27 220 -128 454 -211 594 -211 l43 0 33 -86 c19 -47 36 -101 39 -119 12 -75
-42 -149 -118 -161 -21 -4 -39 -12 -39 -18 0 -8 83 -10 297 -9 276 2 362 11
264 27 -64 10 -100 63 -184 272 l-44 110 71 23 c77 24 219 89 251 115 19 16
19 16 -8 6 -15 -5 -40 -16 -57 -25 -42 -22 -187 -55 -241 -55 -42 0 -47 3 -53
26 -4 15 -5 28 -3 31 2 2 31 8 64 13 32 5 131 28 219 51 174 44 338 60 424 41
24 -6 46 -9 49 -7 9 9 -134 67 -198 81 -133 28 -244 14 -471 -57 -68 -22 -126
-36 -128 -31 -1 5 -8 16 -15 25 -11 14 -18 15 -72 2 -33 -8 -86 -15 -118 -15
-55 0 -58 -1 -52 -21 7 -20 5 -21 -29 -15 -48 9 -46 -1 4 -14 37 -10 66 -39
58 -60 -7 -18 -170 54 -397 175 -46 24 -106 52 -135 61 -28 9 -54 20 -59 23
-4 4 24 86 62 182 37 95 92 236 121 312 29 75 56 137 60 137 4 0 66 -154 139
-342 72 -189 135 -346 140 -351 5 -5 58 3 120 19 92 22 111 30 106 43 -17 46
-219 564 -289 741 l-81 205 -34 -33z m198 -482 c182 -466 176 -429 73 -451
-44 -9 -57 -8 -68 3 -8 7 -67 152 -133 322 -66 169 -129 318 -140 330 -12 12
-21 31 -21 42 0 11 -9 37 -20 59 -11 21 -17 41 -14 44 3 3 35 24 72 48 52 32
70 39 78 30 7 -7 84 -199 173 -427z m-664 -436 c107 -20 139 -33 360 -145 188
-95 291 -139 328 -139 13 0 32 9 42 20 15 17 16 24 7 46 -7 13 -12 28 -12 33
0 4 37 13 82 20 77 12 83 11 109 -8 36 -27 45 -27 148 9 128 43 248 70 320 70
75 0 72 -10 -7 -26 -31 -6 -111 -25 -177 -42 -66 -17 -141 -33 -168 -37 -50
-7 -87 -35 -87 -66 0 -10 12 -31 26 -48 18 -22 27 -45 29 -79 3 -46 42 -147
104 -270 17 -35 29 -67 26 -72 -9 -14 -272 -13 -280 1 -4 5 1 26 10 46 23 48
16 126 -20 218 -39 98 -54 112 -128 120 -88 10 -176 31 -268 65 -78 28 -400
190 -429 215 -8 7 -46 29 -85 48 -82 42 -68 46 70 21z m-89 -600 c4 -20 22
-56 40 -80 19 -24 34 -49 34 -54 0 -6 -42 -10 -105 -10 -68 0 -105 4 -105 11
0 6 17 31 39 57 21 26 46 62 55 80 21 42 33 41 42 -4z"/>
                            <path d="M1921 1375 c-85 -16 -161 -42 -161 -56 0 -12 5 -11 70 6 30 9 100 18
155 20 l100 6 -65 -21 c-178 -56 -230 -76 -230 -86 0 -15 82 0 169 31 105 38
158 46 296 47 122 0 128 1 97 14 -109 47 -299 65 -431 39z"/>
                            <path d="M1300 1250 c0 -15 205 -59 218 -46 3 4 -4 9 -16 13 -16 4 -21 11 -17
23 5 15 -4 17 -90 17 -52 0 -95 -3 -95 -7z"/>
                        </g>
                    </svg>
                </div>
                <div className="loader-line"></div>
            </div>
        </div>
    )
}

export default PageLoading